import { ApiBase } from './apiBase';
import { METHOD } from '../constant/api';

export class ApiHardwares extends ApiBase {
  private static baseUrl: string = '/hardwares';

  static async get(): Promise<any> {
    const url = this.baseUrl;

    const data = {};
    const config = { headers: { Authorization: this.token } };

    return await this.sendRequest(METHOD.GET, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }

  static async post(
    serial: string,
    code: string,
    dealer: string
  ): Promise<any> {
    const url = this.baseUrl;

    const data = {
      device: {
        serial: serial,
        code: code,
        latitude: 0.0,
        longitude: 0.0,
        bleEnabled: true,
      },
      dealer: dealer,
    };
    const config = { headers: { Authorization: this.token } };

    return await this.sendRequest(METHOD.POST, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }

  static async delete(serial: string): Promise<any> {
    const url = this.baseUrl + `/${serial}`;

    const data = {};
    const config = { headers: { Authorization: this.token } };

    return await this.sendRequest(METHOD.DELETE, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }
}
